import React from "react"

import { ChromeConfirmationModal } from "./ChromeConfirmationModal"
import { HotKeyCode } from "../keyboard/HotKeyCode"

type ChromeVoiceAckModalStringKey =
  "caption" | "body1" | "body2" | "acknowledge" | "reject"

export type ChromeVoiceAckModalStrings = Partial<Record<ChromeVoiceAckModalStringKey, string>>

interface ChromePresenceModalProps {
  /**
   * Callback executed when user manually acknowledges speech use.
   */
  onReject?: () => void

  /**
   * Callback executed when user manually refuses speech use.
   */
  onAcknowledge?: () => void
}

/**
 * Acknowledgement modal that is displayed to user when they first log in and speech is enabled.
 */
export class ChromeVoiceAckModal extends React.PureComponent<ChromePresenceModalProps> {
  // override this value to customize strings and provide translations
  public static defaultStrings: ChromeVoiceAckModalStrings = {}

  public static readonly defaultTexts: Record<ChromeVoiceAckModalStringKey, string> = {
    caption: "Use of microphone",
    body1: "PAWS Grocery Voice Picking uses a microphone to record voice inputs while you are using it.",
    body2: "Sign out of the app to stop voice recordings and when not performing this function.",
    acknowledge: "Continue",
    reject: "Sign out",
  }

  public static readonly hotKeys: Record<"acknowledge" | "reject", HotKeyCode> = {
    acknowledge: "Enter",
    reject: "KeyS",
  }

  public render() {
    const { defaultTexts, defaultStrings, hotKeys } = ChromeVoiceAckModal

    return (
      <ChromeConfirmationModal
        id="voiceAcknowledgement"

        caption={{
          stringID: defaultStrings.caption,
          defaultString: defaultTexts.caption,
        }}

        body={{
          stringID: defaultStrings.body1,
          defaultString: defaultTexts.body1,
        }}

        secondaryBody={{
          stringID: defaultStrings.body2,
          defaultString: defaultTexts.body2,
        }}

        primaryButtonHotKey={hotKeys.acknowledge}
        primaryButtonLabel={{
          stringID: defaultStrings.acknowledge,
          defaultString: defaultTexts.acknowledge,
        }}
        onPrimaryButtonClick={this.props.onAcknowledge}

        secondaryButtonHotKey={hotKeys.reject}
        secondaryButtonLabel={{
          stringID: defaultStrings.reject,
          defaultString: defaultTexts.reject,
        }}
        onSecondaryButtonClick={this.props.onReject}
        disablePrimaryButtonUntilScrolledToEnd={true}
      />
    )
  }
}
